var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 27.5H20.6C20.0399 27.5 19.7599 27.5 19.546 27.609C19.3578 27.7049 19.2049 27.8578 19.109 28.046C19 28.2599 19 28.5399 19 29.1V37.5M32.5 27.5H35.4C35.9601 27.5 36.2401 27.5 36.454 27.609C36.6422 27.7049 36.7951 27.8578 36.891 28.046C37 28.2599 37 28.5399 37 29.1V37.5M32.5 37.5V22.7C32.5 21.5799 32.5 21.0198 32.282 20.592C32.0903 20.2157 31.7843 19.9097 31.408 19.718C30.9802 19.5 30.4201 19.5 29.3 19.5H26.7C25.5799 19.5 25.0198 19.5 24.592 19.718C24.2157 19.9097 23.9097 20.2157 23.718 20.592C23.5 21.0198 23.5 21.5799 23.5 22.7V37.5M38 37.5H18M27 23.5H29M27 27.5H29M27 31.5H29",
    stroke: "#0086C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F0F9FF",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobust);
export default __webpack_public_path__ + "static/media/Robust.dbdc9be03cb513a3780bd94bb1a54e5e.svg";
export { ForwardRef as ReactComponent };